<template>
  <Modal
    :title="title"
    :visible="visible"
    :primary-action="{
      label: 'Update',
      onAction: update
    }"
    :secondary-actions="[
      {
        label: 'Cancel',
        onAction: close
      }
    ]"
    overflow-visible
    @afterLeave="afterLeave"
    @close="close"
  >
    <div v-if="col">
      <TextField
        v-if="col.type === 'text'"
        :label="col.label"
        :multiline="col.multiline"
        v-model="value"
      />
      <TextField
        v-if="col.type === 'number'"
        :label="col.label"
        type="number"
        :min="col.min"
        :max="col.max"
        :step="col.step"
        v-model="value"
      />
      <Select
        v-else-if="col.type === 'list'"
        :label="col.label"
        :options="col.options || []"
        :multiple="col.multiple"
        :tags="col.multiple"
        v-model="value"
      />
      <Select
        v-else-if="col.type === 'boolean'"
        :label="col.label"
        :options="[
          {value: true, label: $t('TRUE')},
          {value: false, label: $t('FALSE')}
        ]"
        v-model="value"
      />
      <DatePicker
        v-else-if="col.type === 'date'"
        :label="col.label"
        :with-time="col.withTime"
        clearable
        v-model="value"
      />
      <TimezonePicker
        v-else-if="col.type === 'timezone'"
        :label="col.label"
        v-model="value"
      />
    </div>
  </Modal>
</template>

<script>
import {DatePicker} from '../DatePicker'
import {Modal} from '../Modal'
import {Select} from '../Select'
import {TextField} from '../TextField'
import {TimezonePicker} from '../TimezonePicker'
// import {cloneDeep, isEqualUnordered} from '../../utils'
import {cloneDeep} from '../../utils'

export default {
  components: {
    DatePicker,
    Modal,
    Select,
    TextField,
    TimezonePicker
  },
  data() {
    return {
      visible: false,
      value: null,
      currentValue: null,
      col: null,
      row: null
    }
  },
  computed: {
    title() {
      const {col} = this
      return col ? `Edit "${col.label}"` : null
    }
    // sourceValue() {
    //   return this.row ? this.row.source[this.col.key] : null
    // }
    // hasChanged() {
    //   // return !isEqualUnordered(this.value, this.sourceValue)
    //   return !isEqualUnordered(this.value, this.currentValue)
    // }
  },
  methods: {
    beginEdit(data) {
      const {col, row} = data
      this.currentValue = col.key in row.updates
        ? row.updates[col.key]
        : row.source[col.key]
      this.col = col
      this.row = row
      this.value = cloneDeep(this.currentValue)
      this.visible = true
    },
    update() {
      this.visible = false
      this.$emit('update', this.value)
    },
    afterLeave() {
      this.col = null
      this.row = null
      this.value = null
    },
    close() {
      this.visible = false
    }
  }
}
</script>

<style lang="scss" module>
</style>
